import { render, staticRenderFns } from "./marketHeader.vue?vue&type=template&id=350896da&scoped=true&"
import script from "./marketHeader.vue?vue&type=script&lang=js&"
export * from "./marketHeader.vue?vue&type=script&lang=js&"
import style0 from "./marketHeader.vue?vue&type=style&index=0&id=350896da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350896da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VExpandTransition,VFadeTransition,VIcon,VSheet})
